export default __webpack_public_path__ + "static/media/down_arrow.c1f0da2a.svg";